export default "__VITE_ASSET__c601b101__"